import registrationStep from "../../../registrationStep";
import MinorAddress from "./MinorAddress";

export default registrationStep(MinorAddress, "minors");



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorAddress/index.js